<template>
    <div class="container container--main">
        <div class="content content--main not-found">
            <img src="/shared-img/error.png" alt="Obličej s otevřenou pusou a zvednutým obočím" />
            <h2>Stránka nenalezena</h2>
            <p>Tato stránka neexistuje. Možná byla odstraněna nebo jste zadali nesprávnou adresu.</p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import analytics from "../analytics";

onMounted(() => {
    analytics.sendPageView();
});
</script>
